import type { MetricFormat } from '@data/config/metrics';

/**
 * Formats a metric value string for display.
 * - Adds comma separators for numbers (e.g. "1250" → "1,250")
 * - For 'percent' format: multiplies by 100 and appends "%" (e.g. "0.85" → "85%")
 * - Returns "—" (em dash) for null/undefined/empty values
 * - Returns the original string if it's not a valid number
 */
export function formatMetric(
  value: string | null | undefined,
  format: MetricFormat = 'number'
): string {
  if (!value || value === 'null') return '—';

  const num = Number(value);

  if (Number.isNaN(num)) return value;

  if (format === 'percent') {
    return `${Math.round(num * 100)}%`;
  }

  return num.toLocaleString();
}
